import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue';
import i18n from "@/locale/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveButton',
  props: {
    label: {
        type: String,
        default: ''
    },
},
  emits: ['click', 'doSave'],
  setup(__props, { emit }) {

const props = __props

const t = i18n.global.t;

const buttonLabel = ref('');



// const emit = defineEmits<{(event: 'click', data: { event: MouseEvent }): void;}>();


onMounted(() => {
    if (props.label === '') {
        buttonLabel.value = t("COMMON.BUTTON.SAVE");
    } else {
        buttonLabel.value = props.label;
    }
})

/**
 * 認証ボタン押下
 * @param event 
 */
const saveOption = () => {
    emit('click', { event })
}


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, {
    class: "p-button-success",
    icon: "pi pi-check",
    label: buttonLabel.value,
    onClick: saveOption
  }, null, 8, ["label"]))
}
}

})